const encode = encodeURIComponent
const decode = decodeURIComponent

function parseQuery (query) {
  const res = {}

  query = query.trim().replace(/^(\?|#|&)/, '')

  if (!query) {
    return res
  }
  query.split('&').forEach(param => {
    const parts = param.replace(/\+/g, ' ').split('=')
    const key = decode(parts.shift())
    const val = parts.length > 0 ? decode(parts.join('=')) : ''

    if (key === '') {
      return false
    }
    if (res[key] === undefined) {
      res[key] = val
    } else if (Array.isArray(res[key])) {
      res[key].push(val)
    } else {
      res[key] = val
    }
  })

  return res
}

// 解析字符串为字典格式
function resolveQuery (query, extraQuery = {}) {
  if (query) {
    let parsedQuery = {}
    let index = query.indexOf('?')
    query = index !== -1 ? query.slice(query.indexOf('?') + 1) : ''
    query = query.replace(/(\?|#\/)/g, '&')
    try {
      parsedQuery = parseQuery(query)
    } catch (e) {
      parsedQuery = {}
    }
    for (const key in extraQuery) {
      parsedQuery[key] = extraQuery[key]
    }
    return parsedQuery
  } else {
    return extraQuery
  }
}

// 将字典格式拼接成字符串，带“?”
function stringifyQuery (obj) {
  const res = obj ? Object.keys(obj).sort().map(key => {
    const val = obj[key]

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      const result = []
      val.slice().forEach(val2 => {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key))
        } else {
          result.push(encode(key) + '=' + encode(val2))
        }
      })
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(x => x.length > 0).join('&') : null
  return res ? `?${res}` : ''
}

// 拼接当前location的query
function concatLocalQuery (url = '', json = {}) {
  var objUrlQuery = resolveQuery(url)
  var objLocalQuery = resolveQuery(location.href)
  var newObjQuery = Object.assign({}, objUrlQuery, objLocalQuery, json)
  var strNewQuery = stringifyQuery(newObjQuery)
  var index = url.indexOf('?')
  return (index !== -1 ? url.slice(0, index) : url.slice(0)) + strNewQuery
}

export {
  resolveQuery,
  stringifyQuery,
  concatLocalQuery
}
